import LamaPoll from "./LamaPoll";

export default LamaPoll;
